(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-popup"]) return;
  try {
    
  (function(){
    var DONE_KEY = 'kb_ep_done', DISMISS_KEY = 'kb_ep_dismiss', COUPON_KEY = 'kb_coupon';
    function get(k){ try { return localStorage.getItem(k); } catch(e){ return null; } }
    function set(k,v){ try { localStorage.setItem(k,v); } catch(e){} }

    function init(){
      var root = document.querySelector('[data-ep]');
      if(!root || root.getAttribute('data-ep-ready')) return;
      root.setAttribute('data-ep-ready','1');

      var design = root.dataset.design === 'true';
      var delay = (parseInt(root.dataset.delay,10) || 8) * 1000;
      var days = parseInt(root.dataset.days,10) || 7;
      var code = root.dataset.code || '';
      var percent = parseInt(root.dataset.percent,10) || 10;
      var form = root.querySelector('form');
      var input = root.querySelector('input[type="email"]');
      var errEl = root.querySelector('[data-ep-error]');
      var submit = root.querySelector('[data-ep-submit]');
      var viewForm = root.querySelector('[data-ep-view="form"]');
      var timer = null;

      function open(){
        root.classList.add('is-open');
        root.setAttribute('aria-hidden','false');
        document.body.classList.add('ep-lock');
        if(input && viewForm && !viewForm.hidden && !design) setTimeout(function(){ input.focus({preventScroll:true}); }, 350);
      }
      function close(){
        root.classList.remove('is-open');
        root.setAttribute('aria-hidden','true');
        document.body.classList.remove('ep-lock');
        if(!get(DONE_KEY) && !design) set(DISMISS_KEY, String(Date.now()));
      }
      function grantCoupon(){
        set(DONE_KEY,'1');
        if(code) set(COUPON_KEY, JSON.stringify({ code: code, percent: percent, exp: Date.now() + 14*24*3600*1000 }));
        document.dispatchEvent(new CustomEvent('kb:coupon'));
      }
      function showError(msg){
        if(!errEl) return;
        errEl.textContent = msg || root.dataset.error;
        errEl.hidden = false;
      }

      root.addEventListener('click', function(e){
        if(e.target.closest('[data-ep-close]')){ e.preventDefault(); close(); }
      });
      document.addEventListener('keydown', function(e){
        if(e.key === 'Escape' && root.classList.contains('is-open')) close();
      });

      if(form){
        form.addEventListener('submit', function(e){
          e.preventDefault();
          var email = (input.value || '').trim();
          if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)){ showError(); return; }
          if(errEl) errEl.hidden = true;
          submit.disabled = true; submit.classList.add('is-loading');
          fetch(form.getAttribute('action'), { method:'POST', body:new FormData(form), credentials:'same-origin' })
            .then(function(r){
              if(r.url.indexOf('customer_posted=true') > -1){ grantCoupon(); close(); }
              else if(r.url.indexOf('challenge') > -1){ form.submit(); }
              else { showError(); }
            })
            .catch(function(){ showError(); })
            .then(function(){ submit.disabled = false; submit.classList.remove('is-loading'); });
        });
      }

      /* voltou do captcha / newsletter: inscrição concluída */
      if(location.search.indexOf('customer_posted=true') > -1){
        grantCoupon();
        try { history.replaceState(null, '', location.pathname + location.hash); } catch(e){}
        return;
      }

      if(design){ open(); return; }
      if(get(DONE_KEY)) return;
      var last = parseInt(get(DISMISS_KEY),10);
      if(last && Date.now() - last < days*24*3600*1000) return;

      function tryOpen(){
        var drawer = document.querySelector('.cd.is-open');
        if(drawer){ timer = setTimeout(tryOpen, 5000); return; }
        open();
      }
      timer = setTimeout(tryOpen, delay);
    }

    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function(){
    function init(){
      var track = document.querySelector('[data-pg-track]');
      if(!track) return;
      var slides = track.children;
      var thumbs = document.querySelectorAll('[data-pg-thumb]');
      var thumbsBox = document.querySelector('[data-pg-thumbs]');
      function go(i){
        if(!slides[i]) return;
        track.scrollTo({left: slides[i].offsetLeft - track.offsetLeft, behavior:'smooth'});
      }
      function mark(i){
        thumbs.forEach(function(t,k){ t.classList.toggle('is-active', k===i); });
        if(thumbs[i] && thumbsBox){
          var t = thumbs[i];
          thumbsBox.scrollTo({left: t.offsetLeft - (thumbsBox.clientWidth - t.clientWidth)/2, behavior:'smooth'});
        }
      }
      var current = 0;
      thumbs.forEach(function(t,i){ t.addEventListener('click', function(){ go(i); }); });
      var prev = document.querySelector('[data-pg-prev]'), next = document.querySelector('[data-pg-next]');
      if(prev) prev.addEventListener('click', function(){ go(Math.max(0,current-1)); });
      if(next) next.addEventListener('click', function(){ go(Math.min(slides.length-1,current+1)); });
      var raf;
      track.addEventListener('scroll', function(){
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function(){
          var best = 0, bestD = 1e9, x = track.scrollLeft;
          for(var i=0;i<slides.length;i++){
            var d = Math.abs((slides[i].offsetLeft - track.offsetLeft) - x);
            if(d<bestD){ bestD=d; best=i; }
          }
          if(best!==current){ current=best; mark(best); }
        });
      }, {passive:true});
    }
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["routine-timeline"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(){
      var box = document.querySelector('[data-rt-stories]');
      if(!box) return;
      var vids = box.querySelectorAll('video');
      if('IntersectionObserver' in window){
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            if(e.isIntersecting){ var p = e.target.play(); if(p && p.catch) p.catch(function(){}); }
            else { e.target.pause(); }
          });
        }, {threshold:.6});
        vids.forEach(function(v){ io.observe(v); });
      }
      box.querySelectorAll('[data-rt-sound]').forEach(function(btn){
        btn.addEventListener('click', function(ev){
          ev.stopPropagation();
          var v = btn.parentNode.querySelector('video');
          if(!v) return;
          v.muted = !v.muted;
          btn.classList.toggle('is-on', !v.muted);
        });
      });
    }
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
